import React from 'react';
import { Container, Wrapper, DayNumber, DayStatus } from './CalendarDay.styled';
import { AttendanceIcon, AbsenceIcon, AttendanceText, AbsenceText } from './AttendanceIcons';

interface CalendarDayProps {
  index: number;
  date: Date;
  isToday: boolean;
  isSelected: boolean;
  status?: 'present' | 'absent' | 'late' | 'early_leave';
  onClick: () => void;
}

export const CalendarDay: React.FC<CalendarDayProps> = ({
  index,
  date,
  isToday,
  isSelected,
  status,
  onClick,
}) => {
  // 出席日のみクリック可能
  const isClickable = status === 'present' || status === 'late' || status === 'early_leave';

  // ステータステキスト
  const statusText = {
    present: '出席',
    absent: '欠席',
    late: '遅刻',
    early_leave: '早退',
  };

  // アクセシビリティ用のラベル
  const ariaLabel = `${date.getMonth() + 1}月${date.getDate()}日${
    isToday ? '（本日）' : ''
  }${status ? `, ${statusText[status]}` : ''}${
    isSelected ? ', 選択中' : ''
  }${isClickable ? '' : ', 選択できません'}`;

  return (
    <Container role= 'gridcell'>
      <Wrapper
        $isFirst={index == 0}
        $isLast={index == 6}
        $isSelected={isSelected}
        $isClickable={isClickable}
        onClick={isClickable ? onClick : undefined}
        role={isClickable ? 'button' : 'gridcell'}
        aria-label={ariaLabel}
        aria-current={isToday ? 'date' : undefined}
        aria-pressed={isSelected ? 'true' : undefined}
      >
        <DayNumber aria-hidden="true">
          {date.getDate()}
        </DayNumber>
        {status && (
          <DayStatus aria-hidden="true">
            {(status === 'present' || status === 'late' || status === 'early_leave') ? (
              <>
                <AttendanceIcon />
                <AttendanceText />
              </>
            ) : (
              <>
                <AbsenceIcon />
                <AbsenceText />
              </>
            )}
          </DayStatus>
        )}
      </Wrapper>
    </Container>
  );
};

export default CalendarDay;
